import { render } from "./BaseExport.vue?vue&type=template&id=12deed83"
import script from "./BaseExport.vue?vue&type=script&lang=js"
export * from "./BaseExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__